//英文
export default {
  login: {
    lang:'Language',
    tradeRole: 'Trade Role',
    account: 'Account',
    password: 'Password',
    verificationCode: 'Verification Code',
    login: 'Log In',
    email: 'Email',
    forgetPwd: 'Forget password',
    resetPassword: 'Reset Password',
    logout: 'Log Out',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    cancel: 'Cancel',
    confirm: 'Confirm',
    passwordIncorrectAgain:
      'The password you entered is incorrect. Please try again.',
    pleaseEnterNewPassword: 'Please enter your new password.',
    pleaseEnterOldPassword: 'Please enter your old password.',
    tips: 'Tips',
    savedSuccessfully: 'Saved Successfully.',
    submittedSuccessfully: 'Submitted Successfully.',
    logoutSuccessful: 'Logout Successful.',
    resetSuccessfullyAgain: 'Reset Successfully. Please login again.',
    serverNotRsponding:
      'The server is not responding. Please contact your administrator. ',
    return: 'Return',
    send: 'Send',
    sendCode: 'Send Code',
    PleaseEnterUsername: 'Please enter your username.',
    pleaseEnterPassword: 'Please enter your password.',
    pleaseEnterVerification: 'Please enter the verification code.',
    pleaseEnterEmail: 'Please enter your email.',
    pleaseReenterPassword: 'Please re-enter your new password.',
    passwordResetLogin:
      'Password has been reset successfully. Please login again.',
    pleaseResetPassword: 'Please reset your password.',
    verificationSentInbox:
      'Verification code has been sent. Please check your inbox.',
    noCompanyFoundContact:
      'No Company Found. Please contact your administrator for help.',
    onboardingStatusAbnormal:
      'Onboarding Status Abnormal. Please contact your administrator.',
    loginAgain: 'Login Again',
    noPermission: 'No permission. Please contact your administrator.',
    pswValidatePopover: {
      title: 'Your password must have:',
      rule1: '12-15 characters',
      rule2: 'Include Uppercase character',
      rule3: 'Include Lowercase character',
      rule4: 'Include number and symbol',
    },
    pswNotSame: 'Confirm New Password is inconsistent with the New Password',
    //请输入6位数字验证码
    pleaseEnterSixDigitVerificationCode:
      'Please enter a 6-digit verification code',
    verificationCodeError: 'Verification code error',
    serviceUnavailable: 'Service is temporarily unavailable. Please try again later.',
    signUp: 'Sign up',
    title: "Let's Get Started",
    noAccount: 'Have no account? click ',
    hasAccount: 'Already have an account? click ',
    hasAgree: 'By using the system, you agree to',
    agreement: 'Terms & Conditions',
    register: {
      companyName: 'Company Name',
      name: 'Contact Name',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Login Email',
      phone: 'Mobile Number',
      password: 'Password',
      inviteCode: 'Referral code (Optional)',
      success: 'Success',
      emailCode: 'Email Verification Code',
      resetPwd: 'Success, Please login',
      verificationCode: 'Verification code sent',
    },
    pwdRule: {
      ruletit: 'Your password must have:',
      rule1: 'At least 8 characters long',
      rule2: 'One Uppercase character',
      rule3: 'One Lowercase character',
      rule4: 'One number and symbol',
      ruleTip:
        'For improved security, avoid passwords used with other websites.',
    },
    jsCheck: {
      telephone:'Please enter Phone Number.',
      phoneAreaCode:'Please select Area Code.',
      email: 'Please enter email address.',
      emailFormat: 'Email format error',
      phone: 'Please enter mobile number.',
      phoneFormat: 'Mobile phone number format error',
      confirmPwd: 'Please confirm new password',
      differentPwd: 'Confirmed password and new password do not match.',
      password: 'Please enter password.',
      verCode: 'Please enter verification code.',
      name: 'Please enter contact name.',
      firstName: 'Please enter first name.',
      lastName: 'Please enter last name.',
      newPwd: 'Please enter new password.',
      companyName: 'Please enter company name',
      passwordFormat: 'Password format error'
    },
    changePassword: 'Change Password',
    loginTitle: 'Login to Your Account',
    agree: 'By using the system, you agree to',
    userAgreement: 'Terms',
    privacyPolicy: 'Conditions',
    and: '&',
    forgetPassword: 'Forget password ?',
    registerNow: 'Sign up',
    loginNow: 'Log in',
  },
  common: {
    back: 'Back',
    Select:'Select',
    inputPlaceholder: 'Please Enter',
    selectPlaceholder: 'Please Select',
    documents: 'Documents',
    pleaseUploadClear:
      '(Please upload clear images，we support .pdf, .jpeg, .jpg, .png files)',
    name: 'Name',
    email: 'Email',
    phoneNo: 'Phone No.',
    positionCompany: 'Position at Company',
    IDType: 'ID Type',
    IDNo: 'ID No.',
    plSelect: 'Select',
    IDDocFront: 'ID Doc (Front)',
    IDDocBack: 'ID Doc (Back)',
    countdownMarketClosure: 'Countdown to Market Closure',
    hour: 'h',
    minute: 'm',
    second: 's',
    signedSuccessfully: 'Signed Successfully.',
    startPlaceholder: "From",
    endPlaceholder: "To",
    companyIdentCodePlaceholder: "First 8 digits of the registration No.",
    sample: "Sample",
    certificateFront: "Certificate (Front Side)",
    certificateBack: "Certificate (Back Side)",
    delete: "Delete",
      "fileLimitWarning": " Important: You can only upload {limit} file."
  },
  tips: {
    agreedFollowingTerms:
      '1 you agreed to the following terms of this Platform Service Agreement;',
    constitutesElectronicSignature:
      '2 it constitutes your electronic signature to this Platform Service Agreement for the purposes of the Electronic Transaction Ordinance (Cap. 553 of the laws of Hong Kong).',
    clickingButtonConfirm:
      'By clicking this button, you agree and confirm that:',
    clickAgreeConfirm: 'Please click the button to agree and confirm',
    needAgreementSigning:
      'You need to read the entire agreement before signing.',
    confirmToSign: 'Confirm to sign',
    selectCompanyLogin: 'Please select company to login',
    agreementFirstPlatformServices:
      'You  need to sign the agreement first in order to better provide you with complete platform services.',
    noData: 'No Data',
  },
  enterprise: {
    tellYourCompany: 'Tell Us About Your Company',
    companyInfo: 'Basic Information',
    companyNameChinese: 'Company Name (Chinese)',
    companyNameEnglish: 'Company Name (English)',
    companyDocsType: 'Company Docs Type',
    companyDocsNo: 'Company Docs No.',
    countryIncorporation: 'Country of Incorporation',
    registeredCity: 'Registered City',
    registeredCityElse: 'Registered City',
    registeredAddress: 'Registered Address',
    certificateIncorporation: 'Certificate of Incorporation',
    companyDocsArticlesOrganization:
      'Company Docs (Articles of Association, Organization Chart etc.)',
    businessLicence: 'Business Licence',
    businessRegistration: 'Business Registration Certificate',
    incorporationForm: 'Incorporation Form',
    tellAboutYourself: 'Tell Us About Yourself',
    sameAuthorizedPerson: 'Same as Authorized Person',
    whoBeneficialOwner: 'Who is/are the Beneficial Owner(s) of the company ?',
    BONaturalPerson:
      'BO is any natural person with more than or equal to 25% of stake of the company',
    addBeneficialOwner: 'Add Beneficial Owner',
    deleteBeneficiaryOwner: 'Delete Beneficiary Owner',
    beneficialOwner: 'Beneficial Owner',
    tellYourBankAccount: 'Tell Us About Your Bank Account(s)',
    account: 'Account',
    deleteAccount: 'Delete Account',
    addAccount: 'Add Account',
    currency: 'Currency',
    bankAccountType: 'Bank Account Type',
    accountName: 'Account Name',
    bankAccountNo: 'Bank Account No.',
    bankName: 'Bank Name',
    bankCountry: 'Bank Country',
    bankCity: 'Bank City',
    CNAPSCode: 'CNAPS Code',
    branchName: 'Branch Name',
    bankSWIFTBIC: 'Bank SWIFT BIC',
    intermediaryBankSWIFTBIC: 'Intermediary Bank SWIFT BIC',
    eSignatureSubmit: 'e-Signature and Submit',
    pleaseDownloadDocument: 'Please download and sign the document',
    pleaseUploadDocument: 'Please upload the signed document here',
    download: 'Download',
    companyInformation: 'Company Information',
    personnalInformation: 'Personnal Information',
    accountInformation: 'Account Information',
    previous: 'Previous',
    save: 'Save',
    next: 'Next',
    submit: 'Submit',
    fileUploadedSuccessfully: 'File Uploaded Successfully',
    deleteSuccessfully: 'Delete Successfully',
    dragFilesHere: 'Drag files here or',
    browse: 'Browse',
    supportFormat: '(Each file < 20MB, JPG, PDF and PNG supported)',
    authenticationFailed: 'Authentication Failed',
    retry: 'Retry',
    legalRepresentative: 'Legal Representative',
    director: 'Director',
    info: ' Info',
    deleteDirector: 'Delete Director',
    addDirector: 'Add Director',
    success: 'Success',
    ourTeamReviewInformation: 'Our team will review the information',
    sendConfirmationEmail: 'and send you a confirmation email within 24 hours.',
  },
  bigHome: {
    digitalFinance: 'Digital Finance',
    digitalFinanceContent: 'Innovative Supply Chain Financing Approaches',
    digitalTrade: 'Digital Trade',
    digitalTradeContent:
      'Empowering International Trade with Artificial intelligence & Blockchain Technology',
    pendingTasks: 'Pending Tasks',
    linklogisInternational: 'Linklogis International',
    linklogisInternationalContent:
      'Committed to provide leading digital supply chain financing services to banks, financial institutions and corporates worldwide',
    downloadManagement: 'Manage Downloads',
    No: 'No.',
    fileName: 'File Name',
    status: 'Status',
    createTime: 'Created At',
    action: 'Action',
    download: 'Download',
    topNotice:'Linklogis International rebrands as Unloq to unlock global growth. Learn more details via <a href="' + (["https://cbf-my.wellschain.com","https://cbf-my.unloq.com","https://app.unloq.com","https://app.linklogis.com.hk","https://cbf-my.linklogis.com.hk"].includes(location.origin) ? "https://www.unloq.com/AboutUs" : "https://unloqx.hrlyit.com/AboutUs") + '" target="_blank" style="text-decoration: underline;">here</a>.',
  },
  menu: {
    moreProduct: 'More Product',
  },
  contract: {
    title: 'Digipo Service Schedule',
    download: 'Download',
    submit: 'Submit',
    downloadAndSignfiles: 'Please download and sign the document',
    uploadTheSignedDocument: 'Please upload the signed document here',
    cfcaDigital: "'CFCA Digital Certificate Service'.",
    checkThisBox: 'Select the checkbox and submit to sign the',
    pleaseCheck: 'Please check the "CFCA Digital Certificate Service"',
  },
  cfcaAgreement: {
    title: 'CFCA Electronic Certification Service Agreement',
    checkPrefix: 'I have finished reading and agree to the',
    linkText: 'CFCA Electronic Certification Service Agreement',
    tipScrollToBottom:
      'Please be sure to read the entire agreement. You can check this checkbox only after scrolling to the bottom.',
    tipReadSeconds:
      'To ensure that you have fully understood the content of the agreement, please read for approximately {sec} more seconds.',
    cancel: 'Cancel',
    confirmSigning: 'Confirm Signing',
    msgScrollToBottom: 'Please scroll to the bottom of the agreement first.',
    msgReadMoreSeconds:
      'To ensure you have fully understood the agreement, please read for about {sec} more seconds.',
    msgPleaseCheck:
      'Please check the checkbox to agree before confirming the signing.',
  },
  downloadMgm: {
    fileName: 'File Name',
    status: 'Batch Status',
  },
  productCenter: {
    marketplace: 'Unloq Marketplace',
    marketplaceDes:'Offer a diverse range of assets to achieve efficient transaction matching and generate significant returns.',
    exportDrawback: 'Export Drawback',
    digitalFinance: 'Unloq Finance',
    digitalPayment: 'Unloq Pay',
    DTT: 'Digital Trade Token',
    DTTDes:'A digital trade token payment platform, enabling wallet creation, cross-border settlements, and seamless integration with multiple blockchain networks to support global digital asset transactions.',
    exportDrawbackDes:
      'Fully automatic collection of document data, intelligent matching of customs documents and invoices, lightning tax refund, providing you with one-stop comprehensive export tax refund services.',
    digitalFinanceDes:
      'We provide various financing products, all online, with low interest rates and fast disbursements, to meet your short-term funding needs.',
    digitalPaymentDes:
      'Providing cross-border account services, easily completing overseas account opening, payment and collection, FX and withdrawal, helping cross-border transactions to be fast and secure.',
    activate: 'Activate',
    useNow: 'Use',
    freeTrial: 'Free trial',
    subscribeNow: 'Subscribe',
    inactive: 'Inactive',
    underReview: 'Review',
    failed: 'Failed',
    active: 'Active',
    productActivation: 'Product Activation',
    productActivationDes:
      'Your product activation request has been received. Please contact your account manager directly to proceed with the necessary operations. We appreciate your patience.',
    scanCode: `Wechat scan the code to add an administrator for payment and unlock expert guidance`,
    product: 'Product',
    productCenter: 'Product Center',
    verify: 'Verify',
    kycStatus: 'There are pending KYC processes that need to be completed.'
  },
  exportDrawbackKyc: {
    des1:
      "Please complete your company's basic information and quickly open export drawback product",
    des2:
      "Please fill in authorized person's basic information for certification",
    des3: 'Please upload Authorization Letter',
    enterComInfo: 'Please fill in your company information',
    enterUserInfo: 'Please fill in your information',
    uploadBusinessLicense: 'Please upload the business license',
    businessLicenseTip: `Please ensure that the text is clearly visible and that the maximum upload size is 10M,<br>
      and that the format is limited to pdf, jpg, jpeg, png, bmp`,
    lastName: 'Family Name',
    firstName: 'First Name',
    businessEmail: 'Email',
    contactNo: 'Mobile Phone',
    idNo: 'ID Number',
    idNoFormat: 'ID Number format error',
    companyName: 'Company Name',
    usci: 'Unified Social Credit Code',
    businessType: 'Company Type',
    manuCompany: 'Manufacturing Company',
    tradeCompany: 'Trade Company',
    updateUserTitle: 'Update Login User',
    updateUserTip1: `The authorized person's information is inconsistent with the system's retained login user information. Please confirm if you want to update the login user information?`,
    updateUserTip2: `Click confirm and your login account will be updated to the authorized person's email or mobile phone.
    Confirm`,
    download: 'Download',
    protocolTip: `By checking this box and clicking "Submit",you agree to sign the`,
    pass: 'Pass',
    next: 'Next',
    prev: 'Prev',
    confirm: 'Confirm',
    submit: 'Submit',
    annualReportTip: 'Please upload NAR1/NNC1'
  },
  kycFile: {
    kycUpload: {
      dropFile: 'Drag files here or',
      browse: 'Browse',
      tip:
        'Please ensure that the text is clearly visible and that the maximum upload size is 10M, <br>and that the format is limited to pdf, jpg, jpeg, png, bmp',
      fileTypeMust: 'file type must be .pdf .jpg .jpeg .png .bmp',
      fileSizeNotExceed: 'file size can not exceed 10M, please upload again',
    },
    basicsInfo: {
      atLeastEightchar:'Requires at least 8 characters',
      requireEighteenChar:'Requires exactly 18 characters',
      tit: "Please fill in your company's basic information for certification",
      titTwo:
        "Please upload the registration document and fill in the relevant  basic information of the company",
      uploadBusinessLicense: "Please upload the business license",
      uploadRegistrationCertificate:
        "Please upload the Certificate Of Incorporation",
      otherEnterpriseFile: "Other file",
      constitutionFile: "Please upload the Articles of Association",
      businessFile: "Please upload the business registration certificate",
      financialFile: "Please upload the company's financial report",
      saleFile: "Please upload the sales list",
      equityFile:
        "Please upload the equity structure chart (Any director of the company is required to sign within the last 3 months)",
      companyNameEn: "Company name (English)",
      companyNameCn: "Company name (Local language)",
      blodTip:
        "Tell us about your registered address (the offical address registered with a government body) and business address (the actual place where you conduct your business). They can be same or different.",
      regCountry: "Registered address country",
      regCountryTip: "My business address is same as registered address",
      regAddress: "Registered address",
      opeCountry: "Business address country",
      opeAddress: "Business address",
      companyTip: "Company docs info",
      companyType: "Type of business",
      companyTypeItem1: "General taxpayers",
      companyTypeItem2: "Small-scale enterprises",
      companyCode: "Company docs no.",
      companyStartDate: "Start of document validity",
      companyEndDate: "End of document validity",
      companyDateEver: "My doc does not have an",
      companyCredentias: "Company docs type",
      institutionalType: "Institutional Type",
      companyNameEnTip: "Incorrect format or length for Company name",
      issuedPlaceOfCertificate: "Issued place of certificate",
      issuedPlaceOfCertificateTip: "Please select  Issued place of certificate",
      companyCodeTip: "Incorrect format  for Company code",
      regAddressTip: "Incorrect format  for regAddress",
      opeAddressTip: "Incorrect format  for opeAddress",
      annualReport: 'NAR1/NNC1',
      province: 'Province',
      city: 'City',
      street: 'Street',
      operatingProvince: 'Operating Province',
      operatingCity: 'Operating City',
      operatingStreet: 'Operating Street',
      industry: 'Industry',
      companySize: 'Company Size'
    },
    identityInfo: {
      tit:
        "You will need the consent of a legal entity to open an account.Please tell us the identity of your principal legal person.",
      titSec:
        "You will need the consent of a director to open an account.Please tell us the identity of your principal director.",
      identities:
        "Please select all your identities (multiple selections possible)",
      infomation: "Please fill in your information",
      familyName: "Family name",
      firstName: "First name",
      email: "Email",
      phone: "Phone number",
      areaCode: "Area code",
      docType: "Type of document",
      idNum: "ID Number",
      legalInfo: "Please fill in the information of the legal representative",
      directorInfo:
        "Please fill in the information of the company's directors and list all the directors of the company",
      upIDFront: "Please upload your ID card (front)",
      upIDBack: "Please upload your ID card (reverse side)",
      upCorporate: "Please upload your corporate ID (front)",
      upCorporateBack: "Please upload your corporate ID (reverse side)",
      upNatural:
        "Please upload the identity card (front) of the ultimate beneficiary with 25% or more shareholding",
      upNaturalBack:
        "Please upload the identity card of the ultimate beneficiary with 25% or more shareholding (reverse side)",
      upTip:
        "+UBO（Actual Controller or Shareholders Holding More than 25% of the shares）",
      certificateIssuingPlace: "Certificate issuing place",
      gender: "Gender",
      dateBirth: "Date of Birth",
      male: "Male",
      female: "Female",
      moreThanDirector: "Company Director",
      moreThanShareholding:
        "UBO（Actual Controller or Shareholders Holding More than 25% of the shares）",
      moreThanStockholder:
        "Shareholder（Shareholders Holding More than 25% of the shares）",
      email1: "Please enter email address.",
      emailFormat: "Email format error",
      directoreType: "Type Of Directors",
      stockholderType: "Type Of Stockholder",
      enterprise: "Entity",
      personal: "Individual",
      enterpriseName: "Enterprise Name",
      enterpriseCertificate: "Enterprise Certificate Type",
      enterpriseFile: "Please upload the enterprise file",
      enterpriseCode: "Enterprise ID No",
      enterpriseLocation: "Place of issuance of enterprise certificate",
      remark: "Please list the names of all directors",
      beneficiaryType: 'Type of UBO',
      updateUserTitle: 'Update Login User',
      updateUserTip1: "The authorized person's information is inconsistent with the system's retained login user information. Please confirm if you want to update the login user information?",
      updateUserTip2: "Click confirm and your login account will be updated to the authorized person's email or mobile phone.",
      confirm: 'Confirm',
      contactName: 'Contact Name',
      certificateFrontTip: 'Please upload Certificate (Front Side)',
      certificateBackTip: 'Please upload Certificate (Back Side)'
    },
    openAccountForm: {
      tit: "Please upload the authorization confirmation letter",
      titTwo: "Please agree to sign Authorization Letter",
      downText: "Download Template",
      tip: 'By checking this box and clicking "Submit", you agree to sign the',
      checkServiceAgreement: "Please check the service agreement first",
      agreement: '《CFCA Digital Certificate Service Agreement》',
      subTip: 'Authorization confirmation letter',
    },
    subSuccess: {
      success: "Success",
      tip: "Your information will be verified within 24 hours by our team...",
      btnText: "Back to top",
    },
  },
  preApprovalLogin: {
    companyDetails: 'Company Details',
    description: "Understanding your business nature helps us tailer financing solution best fit your needs",
    monthlySales: 'Monthly Sales',
    businessScope: 'Business Scope',
    next: 'Next',
    select: 'Select',
    success: 'Success',
    revenue: 'Verify Your Revenue',
    description2: 'Sync sales data from your commerce accounts helps us understand your business\'s performance and tailor our financing solutions to your specific needs.',
    commerceAccount: 'Add Commerce Account',
    dataSynced: 'Data successfully synced for {count} account(s)',
    saleData: 'We ask you to sync your sales data with us to...',
    fundApproval: 'Streamline funding approval',
    fundApplication: 'Without collateral! One minute for setup to facilitate seamless funding application',
    financeSolution: 'Customise finance solution',
    tailorProduct: 'Tailor our financing product just for you',
    settlementData: 'Connect to Settlement Data',
    description3: 'Settlement data or bank statements can bolster your application and potentially help you secure a higher credit limit that better meets your needs.',
    submitSuccess: 'Submitted Successfully',
    emailTip: 'We\'re reviewing your application and will get back to you within <br> 24 hours via email.',
    done: 'Done',
    submit: 'Submit',
    logoutSuccess: 'Logout Successful',
    salesPlatform: 'Select sales platform',
    description4: 'All data collected will be secure only to check your eligibility for financing',
    marketplace: 'Choose a marketplace',
    platform: 'Platform',
    storeName: 'Store Name',
    area: 'Area',
    status: 'Status',
    file: 'File',
    uploadFile: 'Upload Files',
    proceed: 'Please upload to proceed',
    syncSuccess: 'Sync Successfully',
    continueTip: 'Please continue in Chrome App',
    continueTip2: 'Continue your operations in our Chrome App to complete.',
    continueTip3: 'Not installed yet? Click the below link to install.',
    appName: 'LLS Finance Assistance',
    continueTip4: 'How it works?',
    continueTip5: 'I’ve Completed the Operation',
    continueTip6: 'Need Support?',
    copyLink: 'Link Copied',
    monthlySalesMiss: 'Monthly Sales missing',
    businessScopeMiss: 'Business Scope missing'
  },
  message: {
    done: 'Done',
    notificationsList: 'Notifications',
    markAsDone: 'Mark as Done',
    message: 'Message',
    todo: 'To-do',
    day: 'd',
    hour: 'h',
    minutes: 'm',
    seconds: 's',
    markAllAsRead: 'Mark All as Read',
    noMessages: 'No messages yet',
    noMessagesTip: 'New messages will appear here.',
    noTodo: 'No task yet',
    noTodoTip: 'New tasks will appear here.',
    end: 'All items shown',
    markAllAsDownloaded: 'Marked All as Downloaded',
    loading: 'Loading...',
    noMoreData: 'No more data'
  }
}
